import { memo } from 'react';
import { Stack } from '@mantine/core';
import { AppScrollArea } from '@/components/ui/AppScrollArea';
import { CountrySelect } from './CountrySelect';
import { MapCenterCard } from './MapCenterCard';
import { ZoomSliders } from './ZoomSliders';
import { BasemapConfig } from './BasemapConfig';
import type { UseMapSetupForm } from '../hooks/useMapSetupForm';

interface MapConfigFormProps {
  /** The configurator form API (values + setters). */
  form: UseMapSetupForm;
}

/**
 * Left-hand form panel for the map configurator page: country, center summary,
 * zoom sliders, and the basemap (default + allowlist) configuration.
 */
export const MapConfigForm = memo(function MapConfigForm({
  form,
}: MapConfigFormProps) {
  const {
    values,
    setCountry,
    setStartZoom,
    setMinZoom,
    setMaxZoom,
    setDefaultBasemap,
    setAllowedBasemaps,
  } = form;

  return (
    <AppScrollArea fill fullBleedGutter="md">
      <Stack gap="lg">
        <CountrySelect value={values.countryCode} onChange={setCountry} />
        <MapCenterCard center={values.center} />
        <ZoomSliders
          startZoom={values.startZoom}
          minZoom={values.minZoom}
          maxZoom={values.maxZoom}
          onStartZoomChange={setStartZoom}
          onMinZoomChange={setMinZoom}
          onMaxZoomChange={setMaxZoom}
        />
        <BasemapConfig
          countryCode={values.countryCode}
          defaultBasemapId={values.defaultBasemapId}
          allowedBasemapIds={values.allowedBasemapIds}
          onDefaultChange={setDefaultBasemap}
          onAllowedChange={setAllowedBasemaps}
        />
      </Stack>
    </AppScrollArea>
  );
});
